import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-office-attendance-config',
  templateUrl: './office-attendance-config.component.html',
  styleUrls: ['./office-attendance-config.component.scss']
})
export class OfficeAttendanceConfigComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
